import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class pollsView_template extends vnTemplate{

    protected getTemplateHtml(): string{
        return `
            <div class="w-form w-form-large form-poll">
               <div class="form-header">
                    <input id="poll-id" data-bind="value: id" type="hidden">
                    <button class="btn icon i-back" type="button" data-bind="event: { click: onClickCancel }">Go Back</button> 
                    <h3 class="form-title icon i-poll">Poll</h3>
                    <button class="btn icon i-edit" type="button" data-bind="event: { click: onClickEdit }">Edit Poll</button>                    
                </div>
                
                <div class="w-form-body">
                    <div class="form-body full-width" style="border-bottom: 0">
                        <strong class="form-sub-title" style="margin-bottom: 0">Info</strong>
                    </div>
                    
               </div>
               
                <div class="w-form-body">
               
                    <div class="form-body">
                    
                        <div class="form-group">
                            <dl class="double-list margin">
                                <dt class="full-width"><span>Name</span></dt>
                                <dd class="full-width"><span data-bind="text: name, valueUpdate: 'keyup'"></span></dd>

                            </dl>
                        </div>
                    
                    </div>
                    
                    <div class="form-body">
                        <div class="form-group">
                            <dl class="double-list margin">
                                <dt class=""><span>Close Date</span></dt>
                                <dd class=""><span data-bind="text: dateClosed()||'Not Selected'"></span></dd>                             
                            </dl>
                        </div>
                    </div>
                    
               </div>
               
                <div class="w-form-body">
                    <div class="form-body full-width" style="border-bottom: 0">
                        <strong class="form-sub-title" style="margin-bottom: 0">Content</strong>
                    </div>
                    
               </div>
               
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                            <dl class="double-list margin">
                                <dt class="full-width"><span>Question</span></dt>
                                <dd class="full-width"><span data-bind="text: description, valueUpdate: 'keyup'"></span></dd>
                                <dt class="full-width"><span>Discussion Article</span></dt>
                                <dd class="full-width"><span data-bind="text: discussionArticle"></span></dd>                          
                            </dl>
                        </div>
                    </div>
                    <div class="form-body">
                        <div class="form-group">
                            <dl class="double-list margin">
                                <dt class=""><span>Type</span></dt>
                                <dd class=""><span data-bind="text: type"></span></dd>
                                <dt><span>Total Voters</span></dt>
                                <dd><span data-bind="text: totalVotes"></span></dd>
                            </dl>
                        </div>
                         
                         <div id="spec_section" class="choices view" >
                            <div id="spec_section_list" data-bind="foreach: choices">
                                <div class="form-group row">
                        
                                    <span  class="form-label"  type="text" data-bind="text: choiceLabel"></span>
                                  
                                      <span class="w-result-bar">
                                        <span class="result-bar" data-bind="style: { width: percentage + '%' }"></span>
                                      </span>
                                  
                                      <!-- ko if: $data.canDelete -->
                                      <span class="form-label result" data-bind="text: percentage + '%, ' + votes + ' Votes'"></span>
                        
                                      <!-- /ko -->
                                </div>
                            </div>    
                         </div>
                    </div>                
               </div>
           
            </div>
            `;
    }

    protected initPartial(): void {

    }

    protected getTemplateName(): string{
        return "pollsView-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return  {
            id: ko.observable()
            ,name: ko.observable("")
            ,description: ko.observable("")
            ,type: ko.observable("")
            ,discussionArticle: ko.observable("")
            ,dateClosed: ko.observable()
            ,choices: ko.observableArray([])
            ,totalVotes: ko.observable("")
            ,onClickCancel: function (data, event) { huit_neuf_this.onClickCancel(data) }
            ,onClickEdit: function (data, event) { huit_neuf_this.onClickEdit(data) }

        };
    }

    public onClickEdit(data){
        this.caller.edit(data.id());
    }

    public onClickCancel(data){
        this.caller.cancel(data.id());
    }


    public setId(id){
        this.getTemplateViewModel().id(id);
    }

    public setName(name){
        this.getTemplateViewModel().name(name);
    }

    public setDescription(description){
        this.getTemplateViewModel().description(description);
    }

    public setDiscussionArticle(discussionArticle){
        this.getTemplateViewModel().discussionArticle(discussionArticle);
    }

    public setType(type){
        this.getTemplateViewModel().type(type);
    }

    public setDateClosed(dateClosed){
        this.getTemplateViewModel().dateClosed(dateClosed);
    }

    public setChoices(choices){
        this.getTemplateViewModel().choices(choices);
    }

    public setTotalVotes(totalVotes){
        this.getTemplateViewModel().totalVotes(totalVotes);
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/pollsView_template.ts